import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
const API_URL = process.env.REACT_APP_STRAPI_URL;

function PageHeader({ data }) {
    return (
        <div key={data.documentId} className="page-header col-sm-12 screen-width" >
            {/*{data.mainTitleText ? <h1>{data.mainTitleText}</h1> : null}*/}

            {/*{data.subTitleText ? <p>{data.subTitleText}</p> : null}*/}

            {/*{data.background ? <p>{data.background}</p> : null}*/}

            {/*{data.headerImage ? <img src={data.headerImage.url} alt="" style={{display: 'none'}}/>: null}*/}

            {/*{data.headerImageMobile ? <img src={API_URL + data.headerImageMobile.url} alt="" />: null}*/}

            {data.headerVideo ?
                // If there is a header video, do this:
                <div className="views-row">
                    <div className={"container-fluid header-div"}>
                        <div className={'row home-page-video-container with-video'}>
                            <video autoPlay muted loop id={"homeHeaderVideo"}>
                                <source src={data.headerVideo.url} type="video/mp4"/>
                                Your browser does not support the video tag.
                            </video>
                            <div className="container header-text-container">
                                <div className="scrollme">
                                    <div className="white-text center-align" style={{maxWidth: '1270px'}}
                                         id="headerMainText">
                                        <div className="animateme" data-when="enter" data-from="0" data-to="1"
                                             data-opacity="0" data-translatey="-50" data-easing="easeinout"
                                             style={{
                                                 opacity: '0.8',
                                                 transform: 'translate3d(0px, -10px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale3d(1, 1, 1)'
                                             }}>
                                            <p className="hero-headline-text fade-title">
                                                {data.mainTitleText} </p>
                                        </div>
                                    </div>
                                    <div className="white-text center-align" id="headerSubText">
                                        <div className="animateme" data-when="enter" data-from="0.5" data-to="1"
                                             data-opacity="0" data-translatey="-50" data-easeinout="easeinout"
                                             style={{
                                                 opacity: '1',
                                                 transform: 'translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale3d(1, 1, 1)'
                                             }}>
                                            <p className="paragraph center-align fade-subtext">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'row home-page-video-container no-video'}>
                            <div className="row header-div-sub header-image-background "
                                 style={{backgroundImage: 'url('.concat(data.headerImage.url).concat(')'), transform: 'translateY(-20px)'}}>
                                <div className="container header-text-container">
                                    <div className="scrollme">
                                        <div className="white-text center-align" id="headerMainText" style={{transform: 'translateY(20px) translateX(-20px)' }}>
                                            <h4 className="section-headline white-text">
                                                {data.mainTitleText} </h4>
                                        </div>
                                        <div className="white-text center-align" id="headerSubText">
                                            <p className="body-text center-align">
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                :
                // If there is no header video, do this instead:
                <div className={"row header-div-sub ".concat(data.background)} style={{}}>
                    <div className="container header-text-container">
                        <div className="scrollme">
                            <div className="white-text center-align" id="headerMainText">
                                <h4 className="section-headline white-text">
                                    {data.mainTitleText}
                                </h4>
                            </div>
                            <div className="white-text center-align" id="headerSubText">
                                <p className="body-text center-align white-text">
                                    {data.subTitleText}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default PageHeader;
